module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bottom-nav-42469626e56f857375815ce3bbf56d30.png";